module.exports = __webpack_public_path__ + "img/spodoptera-exigua.93ddd657.jpg";